import {AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, ViewChild}   from '@angular/core';
import {
  FormStore,
  IEntryComponent
}                                                                               from '../../stores/layout/form.store';
import {BehaviorSubject, combineLatest, debounceTime, Observable, Subscription} from 'rxjs';
import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnHideConfig
}                                                                               from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  delay,
  filter,
  map
}                                                                               from 'rxjs/operators';
import {
  ApplicationMapConfig
}                                                                               from './ap-n-fertilization-planning-configs/application-map.config';
import {
  TargetRateConfig
}                                                                               from './ap-n-fertilization-planning-configs/target-rate.config';
import {
  NFertilizationConfig
}                                                                               from './ap-n-fertilization-planning-configs/n-fertilization.config';
import {
  RapeFertilizationConfig
}                                                                               from './ap-n-fertilization-planning-configs/rape-fertilization.config';
import {
  LanguageStore
}                                                                               from '../../stores/translation/language.store';
import {
  SettingsStore
}                                                                               from '../../stores/base-data/settings.store';
import {
  GetRoundNumericPipe
}                                                                               from '../../ap-utils';
import {
  MapViewStore
}                                                                               from '../../stores/layout/mapview.store';
import {
  ApDynGridPagerWizardBreadcrumbsStepper,
  ApDynGridPagerWizardButton,
  ApDynGridPagerWizardConfig
}                                                                               from '../../ap-dyngrids/config/ap-dyn-grid-pager-wizard-config';
import {
  ApUtilService
}                                                                               from '../../ap-utils/service/ap-util.service';
import {
  ApDynComponentComponent
}                                                                               from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ApDynGridPagerConfigBase
}                                                                               from '../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {
  ApDynformsConfigFieldset
}                                                                               from '../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  BoniturConfig
}                                                                               from './ap-n-fertilization-planning-configs/bonitur.config';
import {
  CropTypeStore
}                                                                               from '../../stores/base-data/crop.types.store';
import {
  Create,
  ObjectFactory
}                                                                               from 'ts-tooling';
import {
  ApDynGridPropertyColumnConfig,
  FilterType
}                                                                               from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  MapViewMode
}                                                                               from '../../ap-interface';
import {
  ApDynGridEditColumnConfig
}                                                                               from '../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {
  ApDynGridStatusColumnConfig
}                                                                               from '../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {
  FieldStore
}                                                                               from '../../stores/farm/field.store';
import {
  IModalDialogData,
  ModalDialogButtonDisable
}                                                                               from '../../ap-interface/interfaces/ap-modaldialog-data.interface';
import {
  TranslationStore
}                                                                               from '../../stores/translation/translation.store';
import {
  ModalDialogStore
}                                                                               from '../../stores/dialog/modal.dialog.store';
import {
  NFertilizationStore
}                                                                               from '../../stores/n-fertilization/n-fertilization.store';
import {
  ApDynGridGroupColumnConfig
}                                                                               from '../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {
  CampaignYearStore
}                                                                               from '../../stores/login/campaignyear.store';
import {
  ApGetCropService
}                                                                               from '../../stores/services/ap-get-crop.service';
import {
  CropRotationStore
}                                                                               from '../../stores/farm/crop.rotation.store';
import {
  ApGetGeomService
}                                                                               from '../../stores/services/ap-get-geom.service';
import {
  LoginStore
}                                                                               from '../../stores/login/login.store';
import {
  OperationModesEnum
}                                                                               from '../../stores/common/operation-modes.store';
import {
  MachineStore
}                                                                               from '../../stores/docu/machine.store';
import {
  DriverStore
}                                                                               from '../../stores/docu/driver.store';
import {
  InstrumentStore
}                                                                               from '../../stores/docu/instrument.store';
import {
  GeneralConfig
}                                                                               from './ap-n-fertilization-planning-configs/general.config';
import {
  FertilizerStore
}                                                                               from '../../stores/base-data/fertilizer.store';
import {
  ApDynformsConfigDatepicker
}                                                                               from '../../ap-dynforms/config/ap-dynforms-config-datepicker';
import {
  ApDynformsConfigTextbox
}                                                                               from '../../ap-dynforms/config/ap-dynforms-config-textbox';
import {
  ApDateService
}                                                                               from '../../ap-core/services/ap-date-service';
import {
  SensorStore
}                                                                               from '../../stores/sensor/sensor.store';
import {
  ApplicationMapAbsoluteConfig
}                                                                               from './ap-n-fertilization-planning-configs/application-map-absolute.config';
import {
  ApplicationSettingsService
}                                                                               from '../../services/data/application-settings.service';
import {
  UniformConfig
}                                                                               from './ap-n-fertilization-planning-configs/uniform.config';
import {
  TargetMapPerPlanConfig
}                                                                               from './ap-n-fertilization-planning-configs/target-map-per-plan.config';
import {
  IGridStatus
}                                                                               from '../../ap-interface/interfaces/ap-grid-status.interface';
import {
  ScanService
}                                                                               from '../../services/data/scan.service';
import {
  ApColumnState
}                                                                               from '../../ap-interface/enums/ap-column-state.enum';
import INFertilizationPlanBook = Data.TaskManagement.INFertilizationPlanBook;
import INFertilizationSummary = Data.TaskManagement.INFertilizationSummary;
import TaskManagementStatus = Data.TaskManagement.TaskManagementStatus;
import ICropTypes = Data.BaseData.ICropTypes;
import IGuid = System.IGuid;
import ISensorFieldData = Data.Sensor.ISensorFieldData;

type SelectedItem = {
  FieldId: IGuid,
  PlanBookId: IGuid
};

// This component currently doesn't in use
@Component({
  selector: 'ap-n-fertilization-edit',
  template: `
    <ap-dyncomponent [loading$]="loading$"
                     [fieldSets]="fieldSets$ | async"
                     [headerIcon]="'ap-icon-n-fertilization'"
                     [columns]="columns$ | async"
                     [items]="items$ | async"
                     [pager]="pager"
                     (edit)="onEdit($event)">
      <div class="ap-form-actions" dynforms.action>
        <div apResponsive
             [sizeMd]="'25-100'"
             [style.text-align]="'left'">
          <button kendoButton
                  [id]="'button_prev'"
                  [type]="'button'"
                  [class]="'button-important'"
                  (apSingleClick)="formPrevious.emit()">
            {{ 'Global_Back_With_Arrow' | translate }}
          </button>
        </div>
        <div apResponsive
             [sizeMd]="'50-100'"
             [style.text-align]="'center'">
          <ap-breadcrumbs-steper [columns]="breadCrumbsColumns"
                                 [selected]="1">
          </ap-breadcrumbs-steper>
        </div>
        <div apResponsive
             [sizeMd]="'25-100'"
             [style.text-align]="'right'">
          <button kendoButton
                  [id]="'button_next'"
                  [type]="'button'"
                  [class]="'button-important'"
                  [themeColor]="'primary'"
                  [disabled]="nextDisabled$ | async"
                  (apSingleClick)="formNext.emit()">
            {{ 'Global_Next_With_Arrow' | translate }}
          </button>
        </div>
      </div>
    </ap-dyncomponent>
  `,
  styles: [],
  providers: [
    ApplicationMapConfig,
    ApplicationMapAbsoluteConfig,
    RapeFertilizationConfig,
    NFertilizationConfig,
    TargetMapPerPlanConfig,
    TargetRateConfig,
    BoniturConfig,
    UniformConfig
  ],
  standalone: false
})
export class ApNFertilizationEditComponent implements OnInit, AfterViewInit, OnDestroy, IEntryComponent {
  /**
   * Implements IEntryComponent
   */
  public Caption$: BehaviorSubject<string> = new BehaviorSubject('');
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;
  public columns$ = new BehaviorSubject<ApDynGridColumnConfigBase[]>(undefined);
  public fieldSets$ = new BehaviorSubject<ApDynformsConfigFieldset[]>([]);
  public items$ = new BehaviorSubject<any[]>([]);
  public loading$: Observable<boolean>;
  public pager: ApDynGridPagerConfigBase;
  public nextDisabled$ = new BehaviorSubject<boolean>(false);
  public formNext = new EventEmitter<void>();
  public formPrevious = new EventEmitter<void>();
  public breadCrumbsColumns = ['Global__Selection', 'Global__Details', 'Admin_Pages__Overview'];

  private _data: any;
  private _selectedFields$ = new BehaviorSubject([]);
  private _overViewGridSubscription: Subscription[] = [];
  private _selectionGridSubscription: Subscription[] = [];
  private _selectedItems: SelectedItem[];
  private _subscriptions: Subscription[] = [];

  constructor(private campaignYearStore: CampaignYearStore,
              private cropRotationStore: CropRotationStore,
              private cropService: ApGetCropService,
              private cropTypeStore: CropTypeStore,
              private driverStore: DriverStore,
              private fertilizerStore: FertilizerStore,
              private fieldStore: FieldStore,
              private formStore: FormStore,
              private generalConfig: GeneralConfig,
              private geomService: ApGetGeomService,
              private instrumentStore: InstrumentStore,
              private languageStore: LanguageStore,
              private loginStore: LoginStore,
              private machineStore: MachineStore,
              private mapViewStore: MapViewStore,
              private modalDialogStore: ModalDialogStore,
              private nFertilizationStore: NFertilizationStore,
              private sensorStore: SensorStore,
              private roundNumericPipe: GetRoundNumericPipe,
              private settingsStore: SettingsStore,
              private translationStore: TranslationStore,
              private dateService: ApDateService,
              private applicationSettingsService: ApplicationSettingsService,
              private applicationMapAbsoluteConfig: ApplicationMapAbsoluteConfig,
              private uniformConfig: UniformConfig,
              private boniturConfig: BoniturConfig,
              private targetRateConfig: TargetRateConfig,
              private applicationMapConfig: ApplicationMapConfig,
              private nFertilizationConfig: NFertilizationConfig,
              private scanService: ScanService,
              private targetMapPerPlanConfig: TargetMapPerPlanConfig,
              private rapeFertilizationConfig: RapeFertilizationConfig) {
  }

  ngOnInit(): void {
    const updateComponentData = this.formStore.Listen(s => s.updateComponent).getValue().data;
    this._data = ObjectFactory.Copy(updateComponentData);
    this._data.dataItem['FertilizationDate'] = this._data.dataItem['FertilizationDate'];
    this._data.dataItem['Product'] = this.fertilizerStore.getFertilizer(this._data.dataItem['ProductId']);
    this._data.dataItem['Group'] = this.fertilizerStore.getGroup(this._data.dataItem['ProductId']);
    this.Caption$.next('Docu_Ini__Edit');
    this.loading$ = combineLatest([
      this.fieldStore.Listen(s => s.loading),
      this.cropRotationStore.Listen(s => s.historyLoading)
    ]).pipe(
      map((loadings) => loadings.some(l => l))
    );
    this._markFormAsTouched();
    this._buildSelectionGrid();
    this._buildSelectionPager();
    this._setSelectionItems();
    this._setSelectionSelectedItems();
  }

  ngAfterViewInit(): void {
    this._subscriptions.push(this.formNext.subscribe(() => this._onFormNext()));
    this._subscriptions.push(this.formPrevious.subscribe(() => this._onFormBack()));
    this._subscriptions.push(this.dynComponent.SelectedItems$.subscribe(items => {
      this.fieldStore.changeSelectedField(items.map(item => item.FieldId.toString()));
    }));
  }

  ngOnDestroy(): void {
    this._selectionGridSubscription.forEach(s => s.unsubscribe());
    this._overViewGridSubscription.forEach(s => s.unsubscribe());
    this._subscriptions.forEach(s => s.unsubscribe());
  }

  public onEdit(dataItem: any): void {
    this.modalDialogStore.setModalDialogData({
      buttons: [
        {
          key: 'cancel',
          text: 'Global__Cancel',
          primary: false
        },
        {
          key: 'apply',
          text: 'Global__Ok',
          primary: true,
          disable: ModalDialogButtonDisable.FormInvalid,
        }
      ],
      show: true,
      title: this.translationStore.FindTranslationForSelectedLanguage('Docu_Ini__Edit'),
      formConfig: {
        fieldSets: this._getFieldSets(this.modalDialogStore.listenChanges(), [dataItem]),
        values: dataItem,
      },
      values: dataItem
    } as IModalDialogData);
    const resultSubscription = this.modalDialogStore.Listen(s => s.result)
      .subscribe((result) => {
        if (result?.key === 'apply') {
          this._updateOverviewItems({ids: [dataItem['Id']], value: ObjectFactory.Copy(result.formValues)});
          resultSubscription.unsubscribe();
        } else if (result?.key === 'cancel') {
          resultSubscription.unsubscribe();
        }
      });
  }

  private _markFormAsTouched(): void {
    setTimeout(() =>
      this._subscriptions.push(this.dynComponent.FormValues$
        .pipe(debounceTime(100), delay(1))
        .subscribe((values) => {
          this.nextDisabled$.next(values['Product'] === null);
          this.dynComponent.dynForm.markAsTouched();
        })
      ), 1);
  }

  private _setSelectionItems(): void {
    this._selectionGridSubscription.push(combineLatest([
      this.fieldStore.Listen(s => s.data).pipe(
        map((fields) =>
          fields.filter((f) =>
            this.cropService.getCrop(f, true, 'object')?.Id === this._data['CropId'])),
      ),
      this.cropRotationStore.Listen(s => s.history),
      this.campaignYearStore.Listen(s => s.selectedYear),
      this.cropTypeStore.Listen(s => s.cropTypesNames),
      this.nFertilizationStore.GetNeeds$(this.campaignYearStore.getSelectedCampaignYear()?.Year),
      this.sensorStore.Listen(s => s.data)
    ]).pipe(
      filter(([fields, cropRotation]) =>
        fields.length !== 0 && Object.keys(cropRotation).length !== 0),
      map(([fields, cropRotation, year, cropTypes, needs, sensorFieldData]) => fields.map((field) => {
        const geom = this.fieldStore.getCurrentFieldGeom(field);
        const fieldCrop = cropRotation[field.Id as string];
        const needValue = needs.find(n => n.FieldId === field.Id);
        const sensorData = sensorFieldData?.Find(_ => _?.FieldGeomId === geom?.Id) as ISensorFieldData;
        let crop: any;
        let cropId: number;
        let status = {
          state: -1,
          class: 'ap-status-red',
          description: 'Global__Inactive',
        };
        if (fieldCrop) {
          cropId = fieldCrop[year.Year].MainCrop;
          status = this._getStatus(cropId);
          crop = cropTypes[cropId];
        }
        return {
          Id: field.Id,
          Field: field,
          FieldId: field.Id,
          Status: status.state,
          StatusClass: status.class,
          StatusDesc: status.description,
          Nr: field.FieldNumber,
          TNr: field.FieldSubnumber,
          NrTNr: this.fieldStore.getFieldNumberAndSubNumber(field),
          Name: field.FieldName,
          Area: geom ? geom.AreaHa : undefined,
          Crop: crop,
          CropId: cropId,
          SecondCropId: (this.cropService.getCrop(field, false, 'object') as ICropTypes)?.Id,
          Geom: geom,
          Kind: '',
          EC: '-',
          Application: '-',
          Date: sensorData?.Created ?? '-',
          Avg: sensorData?.Avg ?? '-',
          Min: sensorData?.Min ?? '-',
          Max: sensorData?.Max ?? '-',
          Sum: '-',
          Remaining: needValue?.Value ?? '-',
          NUptake: '-',
        };
      })),
    ).subscribe((items) => this.items$.next(items)));

    this._selectedItems = this._data.PlanBooks.map((pB: any) => ({PlanBookId: pB.FieldId, FieldId: pB.FieldId}));
  }

  private _setOverviewItems(): void {
    let planBooks: INFertilizationPlanBook[] = this._data['PlanBooks'];
    const summary: INFertilizationSummary = this._data['PlanBooks'][0].Summary;

    const deletePlanBooks = this.nFertilizationStore.Listen(s => s.planBooks).getValue()
      .filter((planBook) =>
        planBook.Summary.Id === summary.Id && planBook.DeletedBy && this._selectedItems.some(x => x.PlanBookId === planBook.Id)
      );
    const newPlanBooks = this._selectedItems
      .filter((selectedItem: SelectedItem) =>
        !planBooks.concat(deletePlanBooks).map((planBook) => planBook.FieldId).Contains(selectedItem.FieldId)
      )
      .map((selectedItem: SelectedItem) => {
        const field = this.fieldStore.getFieldById(selectedItem.FieldId);
        const geom = this.fieldStore.getCurrentFieldGeom(field);
        return {
          FieldGeomId: this.geomService.getGeom(field).Id,
          MainCropId: this.cropService.getCrop(field, true, 'object')?.Id,
          ApplicationMin: summary.UserApplicationMinimum,
          ApplicationRate: summary.UserApplicationRate,
          Summary: summary,
          ECValue: summary.ECValue,
          Slope: summary.Slope,
          Threshold: summary.Threshold,
          ApplicationMax: summary.UserApplicationMaximum,
          ApplicationConst: summary.UserApplicationConstant,
          ApplicationDate: this.dateService.toFarmDateFromUtc(summary.ApplicationDate).toDate(),
          FieldId: field.Id,
          ProductId: planBooks[0].ProductId,
          FarmId: summary.FarmId,
          ApplicationMode: summary.ApplicationMode,
          Area: geom.AreaHa,
          Element: 5,
          OperationMode: summary.OperationMode,
          SecondCropId: this.cropService.getCrop(field, false, 'object')?.Id,
          ValidFrom: planBooks[0].ValidFrom,
          ValidTo: planBooks[0].ValidTo,
          Version: 0,
          Status: TaskManagementStatus.Yellow,
        } as INFertilizationPlanBook;
      });

    planBooks = planBooks
      .filter((planBook) => this._selectedItems.some(x => x.PlanBookId === planBook.Id))
      .concat(newPlanBooks)
      .concat(deletePlanBooks);

    this.items$.next(planBooks.filter(x => this.fieldStore.getFieldById(x.FieldId)).map((planBook: INFertilizationPlanBook): any => {
      const field = this.fieldStore.getFieldById(planBook.FieldId);
      const geom = this.fieldStore.getCurrentFieldGeom(field);
      const driver = this.driverStore.Listen(s => s.data).getValue().find((d) => d.Id === planBook.ExportDriver);
      const machine = this.machineStore.Listen(s => s.data).getValue().find((m) => m.Id === planBook.ExportMachine);
      const instrument = this.instrumentStore.Listen(s => s.data).getValue().find((i) => i.Id === planBook.ExportInstrument);
      const nNeeds = this.nFertilizationStore.GetNeeds$(this.campaignYearStore.getSelectedCampaignYear()?.Year);
      const mainCrop = this.cropTypeStore.getDefaultCroptype(planBook.MainCropId);
      return {
        ...planBook,
        StatusClass: ['ap-status-red', 'ap-status-yellow', 'ap-status-green'][planBook.Status + 1],
        Name: this.fieldStore.getFieldName(field),
        Nr: field.FieldNumber,
        TNr: field.FieldSubnumber,
        NrTNr: this.fieldStore.getFieldNumberAndSubNumber(field),
        FieldId: field.Id,
        Crop: mainCrop?.Description ?? '',
        Date: this.dateService.toFarmDateFromUtc(planBook.ApplicationDate).toDate(),
        Area: geom.AreaHa,
        EppoCode: mainCrop?.Eppocode ?? '',
        Constant: planBook.ApplicationConst,
        Minimum: planBook.ApplicationMin,
        Maximum: planBook.ApplicationMax,
        Threshold: planBook.Threshold,
        ControlFactor: planBook.Summary.Slope,
        ECStage: planBook.ECValue,
        ReferenceValue: planBook.ApplicationRate,
        Amount: planBook.ApplicationRate * planBook.Factor,
        TargetRate: (planBook.ApplicationMin + planBook.ApplicationMax) / 2,
        ControlRange: (planBook.ApplicationMax - planBook.ApplicationMin) / 2,
        ExportDriver: planBook.ExportDriver,
        ExportMachine: planBook.ExportMachine,
        ExportInstrument: planBook.ExportInstrument,
        Driver: driver?.FirstNameFullName,
        Machine: machine?.NameWithSign,
        Instrument: instrument?.Name,
        NNeeds: nNeeds,
        ControlFactorDescription: this.translationStore.FindTranslationForSelectedLanguage(
          planBook.Summary.Slope === 1 ? 'Global__Yield_Oriented' : 'Global__Quality_Oriented'),
        ColumnLoading: false
      };
    }));
  }

  private _buildFormAgronomy(values$: Observable<any>, currentFormValues: () => any): void {
    this.Caption$.next('Global__Details');
    this.columns$.next(undefined);
    this.fieldSets$.next([
      this.generalConfig.getProductFieldSet({
        Group: this._data['Group'],
        Product: this._data['ProductId']
      }, this.dynComponent.FormValues$),
      new ApDynformsConfigFieldset({
        key: 'General',
        legend: 'Global__General_Information',
        config: [
          new ApDynformsConfigDatepicker({
            key: 'FertilizationDate',
            label: 'Nutrients__FertilizationDate',
            minDate: this.campaignYearStore.Listen(s => s.selectedYear).pipe(
              filter((year) => !!year),
              map((year) => new Date(year.DefaultStart))
            ),
            maxDate: this.campaignYearStore.Listen(s => s.selectedYear).pipe(
              filter((year) => !!year),
              map((year) => new Date(year.DefaultEnd))
            ),
            value: this._data['FertilizationDate']
          }),
          new ApDynformsConfigTextbox({
            key: 'Note',
            label: 'Global__Note',
            value: this._data['Note']
          })
        ]
      }),
      this.generalConfig.getDocuFieldSet(this._data, values$, currentFormValues, true),
    ]);
  }

  public _buildSelectionGrid(): void {
    this._selectionGridSubscription.push(combineLatest([
      this.languageStore.Listen(s => s.selectedLanguage),
      this.settingsStore.Listen(s => s.data)
    ]).pipe(
      filter(([language, settings]) => !!language && settings.length !== 0),
      map(([language, settings]) => ({language, setting: settings[0]})),
      map((p) => [
        new ApDynGridStatusColumnConfig({
          field: 'Status',
          class: 'StatusClass',
          description: 'StatusDesc',
          filterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Number',
          field: 'Nr',
          width: 60,
          hide: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          filterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini_Subnumber',
          field: 'TNr',
          width: 60,
          hide: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          filterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Number',
          field: 'NrTNr',
          width: 70,
          filterable: true,
          hide: new ApDynGridColumnHideConfig({
            selfHide: this.mapViewStore.Listen(s => s.mode).pipe(map((mode) => mode === MapViewMode.HIDE))
          })
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Name',
          field: 'Name',
          width: 150,
          filterable: true,
          sortIndex: 0,
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Area',
          field: 'Area',
          width: 100,
          filterable: true,
          tooltip: (dataItem) => dataItem['Area'],
          pipes: [{
            pipe: this.roundNumericPipe,
            args: [p.setting.DigitsAfterDecimalPoint]
          }]
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__Crop',
          field: 'Crop',
          width: 80,
          cropColoring: true,
          filterable: true
        }),
        new ApDynGridGroupColumnConfig({
          title: 'Global__latest_Sensor_reading',
          hide: true,
          groupColumns: [
            new ApDynGridPropertyColumnConfig({
              title: 'Global__EC',
              field: 'EC',
              width: 50,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Application',
              field: 'Application',
              width: 80,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Date',
              field: 'Date',
              format: this.languageStore.CurrentDateFormat,
              width: 70,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__AvgShort',
              field: 'Avg',
              width: 60,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Min',
              field: 'Min',
              width: 60,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Max',
              field: 'Max',
              width: 60,
              filterable: true
            })
          ]
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Nutrients__Remaining_Unit',
          field: 'Remaining',
          width: 60,
          filterable: true
        }),
        new ApDynGridGroupColumnConfig({
          title: 'Settings__Lbl_Menu_Resources',
          hide: true,
          groupColumns: [
            new ApDynGridPropertyColumnConfig({
              field: 'Machine',
              title: 'Base__Engine',
              width: 100,
              hide: true,
            }),
            new ApDynGridPropertyColumnConfig({
              field: 'Instrument',
              title: 'AgriConnect_Ini__Tool',
              width: 100,
              hide: true
            }),
            new ApDynGridPropertyColumnConfig({
              field: 'Driver',
              title: 'Docu_Ini__Motorist',
              width: 100,
              hide: true
            }),
          ]
        }),
      ]),
    ).subscribe(columns => this.columns$.next(columns)));
  }

  private _buildOverviewGrid(): void {
    this._overViewGridSubscription.push(combineLatest([
      this.languageStore.Listen(s => s.selectedLanguage),
      this.settingsStore.Listen(s => s.data)
    ]).pipe(
      filter(([language, settings]) => !!language && settings.length !== 0),
      map(([language, settings]) => ({language, setting: settings[0]})),
      map((p) => {
        const mapHide = this.mapViewStore.Listen(s => s.mode).pipe(
          map((mapMode) => mapMode === MapViewMode.HIDE));
        let result: ApDynGridColumnConfigBase[] = [
          new ApDynGridStatusColumnConfig({
            field: 'Status',
            class: 'StatusClass',
            description: 'StatusDesc',
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini__Number',
            field: 'Nr',
            width: 60,
            hide: true,
            filterType: FilterType.NUMBER,
            cssClass: 'right'
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini_Subnumber',
            field: 'TNr',
            width: 60,
            hide: true,
            filterType: FilterType.NUMBER,
            cssClass: 'right'
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini__Number',
            field: 'NrTNr',
            width: 70,
            hide: new ApDynGridColumnHideConfig({
              selfHide: mapHide
            })
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini__Name',
            field: 'Name',
            width: 150,
            cssClass: 'left',
            sortIndex: 0,
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Docu_Ini__Area',
            field: 'Area',
            width: 60,
            tooltip: (dataItem) => dataItem['Area'],
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [p.setting.DigitsAfterDecimalPoint]
            }],
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Crop',
            field: 'Crop',
            width: 80,
            cropColoring: true,
            hide: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__EC',
            field: 'ECStage',
            width: 50,
            hide: true
          })
        ];

        switch (this._data['OperationModeKey']) {
          case OperationModesEnum.ApplicationMap:
            result = result.concat(this.applicationMapConfig.gridBuilderConfig(mapHide));
            break;
          case OperationModesEnum.ApplicationMapAbsolute:
            result = result.concat(this.applicationMapAbsoluteConfig.gridBuilderConfig(mapHide));
            break;
          case OperationModesEnum.NfTargetMapPerPlan:
            result = result.concat(this.targetMapPerPlanConfig.gridBuilderConfig(mapHide));
            break;
          case OperationModesEnum.TargetValue:
            result = result.concat(this.targetRateConfig.gridBuilderConfig());
            break;
          case OperationModesEnum.NFertilization:
            result = result.concat(this.nFertilizationConfig.gridBuilderConfig());
            break;
          case OperationModesEnum.RapeFertilization:
            result = result.concat(this.rapeFertilizationConfig.gridBuilderConfig());
            break;
          case OperationModesEnum.Constant:
            result = result.concat(this.uniformConfig.gridBuilderConfig(this._data['Product']));
            break;
        }

        result = result.concat([
          new ApDynGridPropertyColumnConfig({
            title: 'Base__SortItemDate',
            field: 'Date',
            format: p.language.DateFormat,
            hide: true,
            width: 90
          }),
          new ApDynGridGroupColumnConfig({
            title: 'Settings__Lbl_Menu_Resources',
            hide: true,
            groupColumns: [
              new ApDynGridPropertyColumnConfig({
                field: 'Machine',
                title: 'Base__Engine',
                width: 100,
                hide: true,
              }),
              new ApDynGridPropertyColumnConfig({
                field: 'Instrument',
                title: 'AgriConnect_Ini__Tool',
                width: 100,
                hide: true
              }),
              new ApDynGridPropertyColumnConfig({
                field: 'Driver',
                title: 'Docu_Ini__Motorist',
                width: 100,
                hide: true
              }),
            ]
          }),
          new ApDynGridEditColumnConfig({})
        ]);

        return result;
      })
    ).subscribe(column => this.columns$.next(column)));
  }

  private _buildSelectionPager(): void {
    this.pager = new ApDynGridPagerWizardConfig(
      new ApDynGridPagerWizardButton('Global_Back_With_Arrow', ApUtilService.createEventEmitter(this.cancel.bind(this), this._selectionGridSubscription)),
      new ApDynGridPagerWizardBreadcrumbsStepper(this.breadCrumbsColumns, 0),
      new ApDynGridPagerWizardButton('Global_Next_With_Arrow', ApUtilService.createEventEmitter(this._onGridNext.bind(this), this._selectionGridSubscription), {
        active: this.dynComponent.SelectedItems$.pipe(
          map((items) => items.length !== 0),
          delay(0)
        ),
        primary: true
      })
    );
  }

  private _buildOverviewPager(): void {
    this.pager = new ApDynGridPagerWizardConfig(
      new ApDynGridPagerWizardButton('Global_Back_With_Arrow', ApUtilService.createEventEmitter(this._onGridBack.bind(this), this._overViewGridSubscription)),
      new ApDynGridPagerWizardBreadcrumbsStepper(this.breadCrumbsColumns, 2),
      new ApDynGridPagerWizardButton('Global__Save', ApUtilService.createEventEmitter(this._onSave.bind(this), this._overViewGridSubscription), {primary: true}),
      {
        formConfig: {
          config: this._getFieldSets(this.dynComponent.PagerValues$, null),
          onSubmit: ApUtilService.createEventEmitter(this._updateOverviewItems.bind(this), this._overViewGridSubscription)
        }
      }
    );
  }

  private _setSelectionSelectedItems(): void {
    this._selectionGridSubscription.push(
      combineLatest([
        this.dynComponent.gridSubject,
        this.items$
      ]).pipe(
        filter(([grid]) => grid !== undefined),
      ).subscribe(
        ([grid]) => {
          grid.gridPaging.setSelectedKeys(this._selectedItems);
        }
      )
    );
  }

  private _setOverviewSelectedItems(): void {
    this._overViewGridSubscription.push(
      this.dynComponent.gridSubject.subscribe(grid => grid?.gridPaging?.setSelectedKeys([]))
    );
  }

  private _getFieldSets(values$: Observable<any>, dataItem: any[] | null = null): ApDynformsConfigFieldset[] {
    let fieldSet = [];
    const operationMode = this._data['OperationModeKey'];
    const selectedItems = !!dataItem && dataItem.length > 0 ? dataItem : this.dynComponent.getSelectedItems();
    const selectedItemsForApplicationSettings = selectedItems.map(x => ({
      EcValue: x.ECStage,
      EppoCode: x.EppoCode
    }));
    const avgNMin = this._selectedFields$.getValue()
      .map(f => this.scanService.getBestScanData(f['Field'], this.getDefaultBestScanStatus()))
      .filter(s => s.Status.state === ApColumnState.Green)
      .map(s => s.NUptakeAvg)
      .Min();
    const applicationSettings = this.applicationSettingsService.getApplicationSetting(
      operationMode, selectedItemsForApplicationSettings[0].EppoCode);
    const cropIds = this._data['PlanBooks'].map((x: any) => x.MainCropId);
    const cropType = this.cropTypeStore.getDefaultCroptype(cropIds[0]);
    switch (operationMode) {
      case OperationModesEnum.ApplicationMap:
        fieldSet = fieldSet.concat(this.applicationMapConfig.formBuilder(this._data, values$.pipe(delay(0)),
          applicationSettings, true, false));
        break;
      case OperationModesEnum.ApplicationMapAbsolute:
        fieldSet = fieldSet.concat(this.applicationMapAbsoluteConfig.formBuilder(this._data, values$.pipe(delay(0)),
          cropType.CropKey, avgNMin, applicationSettings, true, false));
        break;
      case OperationModesEnum.NfTargetMapPerPlan:
        fieldSet = fieldSet.concat(this.targetMapPerPlanConfig.formBuilder(this._data, values$.pipe(delay(0)),
          applicationSettings, true, false));
        break;
      case OperationModesEnum.TargetValue:
        fieldSet = fieldSet.concat(this.targetRateConfig.formBuilder(this._data, values$.pipe(delay(0)),
          applicationSettings, true, false));
        break;
      case OperationModesEnum.NFertilization:
        fieldSet = fieldSet.concat(this.nFertilizationConfig.formBuilder(this._data, values$.pipe(delay(0)),
          applicationSettings, cropType.CropKey, avgNMin, true, false));
        break;
      case OperationModesEnum.RapeFertilization:
        fieldSet = fieldSet.concat(this.rapeFertilizationConfig.formBuilderConfig(this._data, values$.pipe(delay(0)),
          applicationSettings, cropType.CropKey, avgNMin, true, false));
        break;
      case OperationModesEnum.Bonitur:
        fieldSet = fieldSet.concat(this.boniturConfig.formBuilder(this._data, applicationSettings, true,
          false));
        break;
      case OperationModesEnum.Constant:
        const totalArea = selectedItems.map(currentItem => Create(currentItem?.Area, 0))
          .reduce((areaSum, currentArea) => areaSum + currentArea, 0);
        fieldSet = fieldSet.concat(this.uniformConfig.formBuilder(undefined, this._data, values$.pipe(delay(0)),
          totalArea, true));
    }
    return fieldSet;
  }

  private _getStatus(detailsId: number): { state: number, class: string, description: string } {
    const cropType = this.cropTypeStore.getDefaultCroptype(detailsId);
    const result = {state: undefined, class: undefined, description: undefined};
    if (cropType && cropType.IsSensorCrop) {
      result.state = 1;
      result.class = 'ap-status-green';
      result.description = 'Global__Active';
    } else if (cropType) {
      result.state = 0;
      result.class = 'ap-status-yellow';
      result.description = 'Global__Inactive';
    } else {
      result.state = -1;
      result.class = 'ap-status-red';
      result.description = 'Global__Inactive';
    }

    return result;
  }

  private _onFormBack(): void {
    this.fieldSets$.next([]);
    this._setSelectionItems();
    this._setSelectionSelectedItems();
    this._buildSelectionGrid();
    this._buildSelectionPager();
  }

  private _onGridBack(): void {
    this._overViewGridSubscription.forEach(s => s.unsubscribe());
    this.fieldStore.changeSelectedField(this._selectedItems.map(x => x.FieldId.toString()));
    this._buildFormAgronomy(this.dynComponent.dynForm.FormValues$, this.dynComponent.dynForm.form.getRawValue);
  }

  private _onFormNext(): void {
    const value = this.dynComponent.dynForm.form.value;
    this._data['Product'] = value.Product;
    this._data['Group'] = value.Group;
    this._data['Driver'] = value.Driver;
    this._data['Machine'] = value.Machine;
    this._data['Instrument'] = value.Instrument;
    this._data['FertilizationDate'] = value.FertilizationDate;
    this._data['Note'] = value.Note;

    this.fieldSets$.next([]);

    this._buildOverviewGrid();
    this._buildOverviewPager();
    this._setOverviewItems();

    setTimeout(() => this._setOverviewSelectedItems(), 1);
  }

  private _onGridNext(): void {
    this._selectionGridSubscription.forEach(s => s.unsubscribe());
    this._selectedItems = this.dynComponent.getSelectedItems().map((item: any) => ({
      PlanBookId: item.Id,
      FieldId: item.FieldId
    }));
    this._selectedFields$.next(this.dynComponent.getSelectedItems());
    this.fieldStore.changeSelectedField(this._selectedItems.map(x => x.FieldId.toString()));
    this._buildFormAgronomy(this.dynComponent.dynForm.FormValues$, this.dynComponent.dynForm.form.getRawValue);
  }

  private _onClose(): void {
    this.fieldStore.changeSelectedField([]);
    this.formStore.closeForm();
  }

  private cancel() {
    this._onClose();
    this.formStore.navigateToParamUrl();
  }

  private _onSave(): void {
    const planBooks = this.items$.getValue().map((field) => {
      const summary: INFertilizationSummary = ObjectFactory.Copy(field['Summary']);
      summary.ApplicationDate = this._data['FertilizationDate']?.toISOString();
      summary.Title = this._data['Note'];
      return {
        ProductId: this._data['Product'],
        ApplicationMode: field['ApplicationMode'],
        OperationMode: field['OperationMode'],
        FieldGeomId: field['FieldGeomId'],
        MainCropId: field['MainCropId'],
        ApplicationConst: field['Constant'],
        ApplicationDate: field['Date'],
        ApplicationMax: field['Maximum'],
        ApplicationMin: field['Minimum'],
        ApplicationRate: field['OperationMode'].Key !== 'Global__RateConst' ? field['OperationMode'].Key !== 'OpMode_TargetRateN' ? field['Amount'] : field['TargetRate'] : field['Constant'],
        ECValue: field['ECStage'],
        Element: 5,
        Slope: field['Slope'],
        SecondCropId: field['SecondCropId'],
        Threshold: field['Threshold'],
        FieldId: field['FieldId'],
        Geom: undefined,
        Summary: summary,
        Status: field['Status'],
        Area: field['Area'],
        Id: field['PlanBookId'],
        Note: field['Note'],
        ExportDriver: this._data['Driver']?.Id ?? null,
        ExportMachine: this._data['Machine']?.Id ?? null,
        ExportInstrument: this._data['Instrument']?.Id ?? null,
        FarmId: this.loginStore.SelectedFarmId,
      } as INFertilizationPlanBook;
    });
    this.nFertilizationStore.UpdateNFertilizationPlanning(planBooks);
    this.fieldStore.changeSelectedField([]);
    this.formStore.closeForm();
  }

  private _updateOverviewItems(submitData: { ids: any[], value: any }): void {
    this.items$.next(this.items$.getValue().map((item) => {
      if (submitData.ids.includes(item.Id)) {
        const date = item['Date'];
        item = ObjectFactory.Merge(ObjectFactory.Copy(item), submitData.value);
        item['Date'] = date;
        if (item['OperationModeKey'] === OperationModesEnum.TargetValue) {
          item['Minimum'] = item['TargetRate'] - item['ControlRange'];
          item['Maximum'] = item['TargetRate'] + item['ControlRange'];
        }
      }
      return item;
    }));
  }

  private getDefaultBestScanStatus(): IGridStatus {
    return {
      state: ApColumnState.Red,
      class: 'ap-status-grey',
      description: ''
    };
  }
}
